import { createContext, ReactNode, useContext } from 'react';

/** @public */
export interface OptionConfigContextValue {
  isNativePdp: boolean;
  isResize: boolean;
  visibility: boolean;
}

/** @public */
export const OptionConfigContext = createContext<OptionConfigContextValue>({
  isNativePdp: false,
  isResize: false,
  visibility: false,
});

/** @public */
export const useOptionConfig = () => useContext(OptionConfigContext);

/** @public */
export interface OptionConfigProviderProps extends OptionConfigContextValue {
  children: ReactNode;
}

/** @public */
export function OptionConfigProvider({ children, ...value }: OptionConfigProviderProps) {
  return <OptionConfigContext.Provider children={children} value={value} />;
}
